var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentApplicationsTotal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "discussion",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.466,
    height: 36.781,
    viewBox: "0 0 35.466 36.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_47263",
    "data-name": "Group 47263",
    transform: "translate(10.283 16.71)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2751",
    "data-name": "Ellipse 2751",
    cx: 4.027,
    cy: 4.027,
    rx: 4.027,
    ry: 4.027,
    transform: "matrix(0.34, -0.94, 0.94, 0.34, 2.282, 7.57)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54444",
    "data-name": "Path 54444",
    d: "M170.831,374.258a7.451,7.451,0,0,0-14.9,0Z",
    transform: "translate(-155.93 -356.877)",
    fill: "#ffda2d",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47264",
    "data-name": "Group 47264",
    transform: "translate(20.585 19.943)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2752",
    "data-name": "Ellipse 2752",
    cx: 4.027,
    cy: 4.027,
    rx: 4.027,
    ry: 4.027,
    transform: "matrix(0.987, -0.16, 0.16, 0.987, 2.815, 1.289)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54445",
    "data-name": "Path 54445",
    d: "M309.177,409.989a7.451,7.451,0,0,0-14.881,0,.372.372,0,0,0,.372.392h14.137a.372.372,0,0,0,.372-.392Z",
    transform: "translate(-294.296 -393.543)",
    fill: "#64b5f6",
    fillRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47265",
    "data-name": "Group 47265",
    transform: "translate(0 18.989)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2753",
    "data-name": "Ellipse 2753",
    cx: 4.027,
    cy: 4.027,
    rx: 4.027,
    ry: 4.027,
    transform: "translate(1.868 6.725) rotate(-56.58)",
    fill: "#ffd6bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54446",
    "data-name": "Path 54446",
    d: "M32.707,409.989a7.451,7.451,0,0,0-14.881,0,.372.372,0,0,0,.372.392H32.335a.372.372,0,0,0,.372-.392Z",
    transform: "translate(-17.825 -392.589)",
    fill: "#64b5f6",
    fillRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_47266",
    "data-name": "Group 47266",
    transform: "translate(5.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54447",
    "data-name": "Path 54447",
    d: "M222.311,53.5H208.794a1.036,1.036,0,0,0-1.034,1.034V63a1.036,1.036,0,0,0,1.034,1.034h7.687l4.38,3.145V64.038h1.45A1.036,1.036,0,0,0,223.345,63v-8.47a1.037,1.037,0,0,0-1.034-1.034Z",
    transform: "translate(-199.358 -50.186)",
    fill: "#64b5f6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54448",
    "data-name": "Path 54448",
    d: "M95.948,82.444h13.516a1.036,1.036,0,0,1,1.034,1.034v8.47a1.036,1.036,0,0,1-1.034,1.034h-7.687L97.4,96.127V92.983h-1.45a1.036,1.036,0,0,1-1.034-1.034v-8.47A1.036,1.036,0,0,1,95.948,82.444Z",
    transform: "translate(-94.914 -76.976)",
    fill: "#72d561",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54449",
    "data-name": "Path 54449",
    d: "M133.885,9H147.4a1.036,1.036,0,0,1,1.034,1.034V18.5a1.036,1.036,0,0,1-1.034,1.034h-7.687l-4.38,3.145V19.539h-1.45A1.036,1.036,0,0,1,132.85,18.5v-8.47A1.037,1.037,0,0,1,133.885,9Z",
    transform: "translate(-130.025 -9)",
    fill: "#ffda2d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54450",
    "data-name": "Path 54450",
    d: "M166.879,40.209a.6.6,0,1,1,0-1.191h9.416a.6.6,0,0,1,0,1.191Zm0,2.635a.6.6,0,1,1,0-1.191h9.416a.6.6,0,0,1,0,1.191Zm0-5.27a.6.6,0,1,1,0-1.191h9.416a.6.6,0,0,1,0,1.191Z",
    transform: "translate(-160.969 -34.344)",
    fill: "#eff4f7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentApplicationsTotal);
export default __webpack_public_path__ + "static/media/student-applications-total.1c76b5527b609cf1a152a1781b1db721.svg";
export { ForwardRef as ReactComponent };